module.exports = __webpack_public_path__ + "static/media/quality (2).6f8da2ba.svg";